import React from 'react';
import { Card, CardContent, Container, Stack } from '@mui/material';
import { PlayerHeader } from './PlayerHeader';

export function PlayerCardLayout({ children, header }) {
  const resolvedHeader = {
    appName: header?.appName || 'Digital Escape Room',
    quizTitle: header?.quizTitle || 'Digital Escape Room',
    showLogo: header?.showLogo ?? false,
    logoUrl: header?.logoUrl || null
  };

  return (
    <Container maxWidth="md">
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <PlayerHeader
              appName={resolvedHeader.appName}
              quizTitle={resolvedHeader.quizTitle}
              showLogo={resolvedHeader.showLogo}
              logoUrl={resolvedHeader.logoUrl}
            />
            {children}
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
